const regixPassword = "^(?=.*[A-Za-z])(?=.*d)(?=.*[@$!%*#?&])[A-Za-zd@$!%*#?&]{8,}$";
const regixEmail = "([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|\"([]!#-[^-~ \t]|(\\[\t -~]))+\")@([!#-'*+/-9=?A-Z^-~-]+(.[!#-'*+/-9=?A-Z^-~-]+)*|[[\t -Z^-~]*])";
export const ValidationIndividual = (values) => {
    const error = {};
    if (!values.country) {
        error.country = "Please select country";
    }
    if (!values.countryCode) {
        error.countryCode = "Please select country code";
    }
    if (!values.phoneNumber) {
        error.phoneNumber = "Phone number fied is empty";
    }
    if (!values.userName) {
        error.userName = "Username fied is empty";
    }
    if (!values.password) {
        error.password = "Password fied is empty";
    }
    if (values.confirmPassword !== values.password) {
        error.confirmPassword = "Password does not match";
    }
    if (!values.agree) {
        error.agree = "Please check the box";
    }
    if (!values.firstName) {
        error.firstName = "First name fied is empty";
    }
    if (!values.lastName) {
        error.lastName = "Last name fied is empty";
    }
    if (!values.personalEmail && !values.personalEmail !== undefined) {
        error.personalEmail = "Personal email address fied is empty";
    }
    return error;
};
export const ValidationCorporate = (values) => {
    const error = {};
    if (!values.country) {
        error.country = "Please select country";
    }
    if (!values.countryCode) {
        error.countryCode = "Please select country code";
    }
    if (!values.phoneNumber) {
        error.phoneNumber = "Phone number fied is empty";
    }
    if (!values.userName) {
        error.userName = "Username fied is empty";
    }
    if (!values.password) {
        error.password = "Password fied is empty";
    }
    if (values.confirmPassword !== values.password) {
        error.confirmPassword = "Password does not match";
    }
    if (!values.agree) {
        error.agree = "Please check the box";
    }
    if (!values.fullName) {
        error.firstName = "First name fied is empty";
    }
    if (!values.lastName) {
        error.lastName = "Last name fied is empty";
    }
    if (!values.personalEmail && !values.personalEmail !== undefined) {
        error.personalEmail = "Personal email address fied is empty";
    }
    if (!values.companyName) {
        error.companyName = "Company name is required";
    }
    if (!values.companyEmail) {
        error.companyEmail = "Company email address fied is empty";
    }
    return error;
};
export const ValidationCompany = (values) => {
    const errors = {};
    if (!values.country) {
        errors.country = "Country fied is empty";
    }
    if (!values.countryCode) {
        errors.countryCode = "Please choose your gender";
    }
    if (!values.phoneNumber) {
        errors.phoneNumber = "Phone number fied is empty";
    }
    if (!values.userName) {
        errors.userName = "Username fied is empty";
    }
    if (!values.password) {
        errors.password = "Password fied is empty";
    }
    if (values.confirmPassword !== values.password) {
        errors.confirmPassword = "Password does not match";
    }
    if (!values.companyName) {
        errors.companyName = "Company name is required";
    }
    if (!values.companyEmail) {
        errors.companyEmail = "Company email address fied is empty";
    }
    if (values.agree === false) {
        errors.agree = "Please check the box";
    }
    return errors;
};
export const changePassword = (values) => {
    const errors = {};
    if (values.confirmPassword !== values.password) {
        errors.confirmPassword = "Password does not match";
    }
    return errors;
};
